<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="select_container">
      <el-button type="primary" class="el-icon-plus" @click="addFormVisible = true">添加子目录</el-button>
    </div>
    <div class="table_container">
      <el-table
        :data="tableData"
        highlight-current-row
        style="width: 100%">
        <el-table-column
          prop="sort"
          label="序号"
          width="100">
        </el-table-column>
        <el-table-column
          property="parentName"
          label="分类名称">
        </el-table-column>
        <el-table-column
          property="typeName"
          label="子目录">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="120">
          <template slot-scope="scope" >
            <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>

      <!--&lt;!&ndash;新增排版&ndash;&gt;-->
      <el-dialog title="新增分类"  :visible.sync="addFormVisible" :close-on-click-modal="false" v-loading="loading">
        <el-form :model="addForm" label-width="80px" ref="addForm">
          <el-form-item label="课程分类" prop="classify">
            <el-select v-model="addForm.classify" placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.typeId"
                :label="item.typeName"
                :value="item.typeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类名称" >
            <el-input v-model="addForm.name" auto-complete="off" maxlength="8" ></el-input>
          </el-form-item>
          <el-form-item label="分类排序" >
            <el-input v-model="addForm.sort" auto-complete="off" maxlength="8" ></el-input>
          </el-form-item>
          <el-form-item label="图片附加" >
            <el-upload
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemove"
              :on-success='handlesuccess'
              :headers="myHeaders"
              :before-upload="beforeUploadimg"
              multiple
              :limit="1"
              :data = "{type:1}"
              :file-list="fileList"
              :on-exceed="handleExceed"
              list-type="picture">
              <div slot="tip" class="el-upload__tip">请上传213×149的jpg/png图片，且不超过500kb</div>
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="addSubmit()" >提交</el-button>
        </div>
      </el-dialog>

      <el-dialog title="编辑" :visible.sync="dialogFormVisible" v-loading="loading">
        <el-form :model="form" label-width="80px" ref="addForm">
          <el-form-item label="分类名称" prop="classify" >
            <el-select v-model="form.classify" placeholder="请选择" >
              <el-option
                v-for="item in options"
                :key="item.typeId"
                :label="item.typeName"
                :value="item.typeId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="分类名称">
            <el-input v-model="form.name" autocomplete="off" maxlength="8"></el-input>
          </el-form-item>
          <el-form-item label="分类排序" prop="name">
            <el-input v-model="form.sort" auto-complete="off" maxlength="8" ></el-input>
          </el-form-item>
          <el-form-item label="最新图片" prop="name">
            <el-upload
              action="http://mapi.eduscb.com/smallpargramback/updaloFile/upload"
              :on-remove="handleRemoves"
              :on-success='handlesuccesss'
              :headers="myHeaders"
              :before-upload="beforeUploadimg"
              multiple
              :limit="1"
              :data = "{type:1}"
              :file-list="fileList"
              :on-exceed="handleExceed"
              list-type="picture">
              <div slot="tip" class="el-upload__tip">请上传213×149的jpg/png图片，且不超过500kb</div>
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="原图:" prop="name">
            <img v-bind:src="form.backImage" style="width: 80%">
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="addSubmits()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>


<script>
  import headTop from '../components/headTop'
  import { getClassification,getClassificationSub,getAddHotClassification,getModHotClassification,getDelCurriculum } from "../api/api"
  export default {
    inject: ['reload'],
    data () {
      return {
        tableData: [],
        options:[],
        fileList:[],
        limit: 20,
        total: 0,
        currentPage: 1,
        addFormVisible: false,
        dialogFormVisible:false,
        addForm:{
          name:'',
          classify:'',
          sort:'',
          backImage:''
        },
        form:{
          name:'',
          classify:'',
          sort:'',
          backImage:''
        },
        loading:false,
        myHeaders: {token: sessionStorage.token},
      }
    },
    components: {
      headTop,
    },
    methods:{
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
      },
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getClassificationSub()
      },
      getCurriculum (){
        // 获取二级列表数据
        let params={
          category:2,
          pageNum:this.currentPage,
          pageSize:this.limit,
        };
        getClassification(params).then(res=>{
          this.options = res.pageInfo
        }).catch(error=>{
          console.log(error);
        })
      },
      getClassificationSub(){
        // 获取一级分类列表数据
        let params={
          category:2,
          pageNum:this.currentPage,
          pageSize:this.limit,
        };
        getClassificationSub(params).then(res=>{
          this.tableData = res.pageInfo
          this.total = res.total
        }).catch(error=>{
          console.log(error);
        })
      },
      //新增子目录
      handlesuccess(response, file, fileList){
        if(file.response.state == true){
          this.addForm.backImage = file.response.url
        }else{
          console.log('解析失败')
        }
      },
      //添加分类
      addSubmit(){
        if (this.addForm.name == '' || this.addForm.classify == '' || this.addForm.sort == '' || this.addForm.sort == '0'|| this.addForm.backImage ==''){
          this.$message({
            type: 'error',
            message: '请输入正确信息'
          });
        } else {
          this.loading = true
          let params={
            typeName:this.addForm.name.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g,''),
            category:2,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
            parentId:this.addForm.classify,
            sort:this.addForm.sort,
            backImage:this.addForm.backImage
          };
          getAddHotClassification(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.fileList = []
              this.loading = false
              this.addFormVisible = false
              this.getClassificationSub();
              this.addForm = {}
            }else{
              this.$message({
                type: 'error',
                message: '请上传正确信息'
              });
              this.loading = false
            }
          }).catch(error=>{
            this.loading = false
            console.log(error)
          })
        }
      },
      cancel(){
        this.addForm = {}
        this.addFormVisible = false
      },
      //编辑
      handleEdit(index, row) {
        console.log(row)
        this.dialogFormVisible = true
        this.form.name = row.typeName
        this.form.classify = row.parentId
        this.form.parentId = row.typeId
        this.form.sort= row.sort
        this.form.backImage = row.backImage
      },
      //编辑子目录
      handlesuccesss(response, file, fileList){
        if(file.response.state == true){
          this.form.backImage = file.response.url
        }else{
          console.log('解析失败')
        }
      },
      //修改分类名称
      addSubmits(){
        if (this.form.name == '' || this.form.sort == '' || this.form.sort == '0'){
          this.$message({
            type: 'error',
            message: '请输入正确信息'
          });
        } else {
          this.loading = true
          let params = {
            typeName: this.form.name.replace(/[^A-Za-z0-9\u4e00-\u9fa5]/g,''),
            typeId: this.form.parentId,
            category: 2,
            operationId: JSON.parse(sessionStorage.getItem('user')).id,
            parentId:this.form.classify,
            sort:this.form.sort,
            backImage:this.form.backImage
          };
          getModHotClassification(params).then(res => {
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.fileList = []
              this.loading = false
              this.dialogFormVisible = false
              this.getClassificationSub()
            } else {
              this.$message({
                type: 'error',
                message: '请上传正确信息'
              });
              this.loading = false
            }
          }).catch(error => {
            this.loading = false
            console.log(error)
          })
        }
      },

      handleDelete(index, row){
        //删除
        this.$confirm('确认删除该记录吗？', '提示', {
          // type: 'warning'
        }).then(() => {
          let params={
            typeId:row.typeId,
            operationId:JSON.parse(sessionStorage.getItem('user')).id,
            category:2,
            parentId:row.parentId,
            sort:row.sort
          };
          getDelCurriculum(params).then(res=>{
            if (res.state == true) {
              this.$message({
                type: 'success',
                message: res.msg
              });
              this.getClassificationSub()
              this.tableData.splice(index, 1);
            }else{
              throw new Error(res.message)
            }
          }).catch(error=>{
            this.$message({
              type: 'error',
              message: res.msg
            });
          })
        }).catch(() => {
        })
      },
      beforeUploadimg(file) {
        if (['image/jpg', 'image/png', 'image/jpeg', 'image/gif'].indexOf(file.type) == -1) {
          this.$message.error('请上传正确的图片格式');
          return false
        }
      },
      handleRemove(file, fileList) {
        this.addForm.backImage = ''
      },
      handleRemoves(file, fileList) {
        this.addForms.backImage = ''
      },
      handleExceed(files, fileList) {
        this.$message.warning(`最多上传一张图片`);
      },
    },
    activated(){
      this.getCurriculum()
      this.getClassificationSub()
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';

</style>
。



// WEBPACK FOOTER //
// src/page/subdirectoryhot.vue